import React from 'react';

import { Box, styled, useTheme } from '@mui/material';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import { MODULES_TRANSLATION_PATH } from '../helpers/constants';
import { RoleTree, RoleTreeWithPermissions } from '../types';

const StyRoleSwitchContainer = styled(Box)(() => ({
    alignItems: 'center',
    display: 'flex',
}));

type Props = {
    roleTree: RoleTree | RoleTreeWithPermissions;
    isSwitchSelected: () => boolean;
    handleSwitchEvent: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

/**
 * Component aimed to display the sub role switch into user roles edition view.
 */
const SubRoleSwitch = (props: Props): JSX.Element => {
    const { roleTree, isSwitchSelected, handleSwitchEvent } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <StyRoleSwitchContainer>
            <Switch checked={isSwitchSelected()} onChange={handleSwitchEvent} />
            <Typography variant="body1Bold">
                {t(`${MODULES_TRANSLATION_PATH}.titles.${roleTree.roleName}`)}
            </Typography>
            <Tooltip
                title={t(
                    `${MODULES_TRANSLATION_PATH}.descriptions.${roleTree.roleName}`,
                )}
            >
                <InfoIcon
                    fontSize="medium"
                    sx={{
                        color: theme.palette.darkGrey,
                        margin: `0 ${theme.spacing(1)}`,
                    }}
                />
            </Tooltip>
        </StyRoleSwitchContainer>
    );
};

export default SubRoleSwitch;
